type TrackingInput<TUrl extends string | null | undefined> = {
  url: TUrl;
  location: string;
  name: string;
};

export const trackAnalyticsNew = <TUrl extends string | null | undefined>({
  url,
  location,
  name,
}: TrackingInput<TUrl>) => ({
    url,
    dataTrackingId: name,
    dataTrack: location,
  });
